var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConnectorFlightStop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "322px",
    viewBox: "0 0 12 322",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "624CAB81-132B-452C-88C5-A5DBD4F73D41") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KLM_Flightcards",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "KLM/Flightcards_Mobile_withdates",
    transform: "translate(-468, -714)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "KLM/Flightcard/Mobile/Dates/Overstap/Selected/Details",
    transform: "translate(452, 240)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Flightconnector/Vertical/XLarge/Transfer",
    transform: "translate(16, 474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-30.5,160.5 C7.35185185,160.5 31.6851852,160.5 42.5,160.5",
    id: "Path-Copy",
    stroke: "#00A1DE",
    strokeWidth: 2,
    strokeDasharray: "2,2",
    transform: "translate(6, 160.5) rotate(90) translate(-6, -160.5)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -53.5,
    y1: 65.5,
    x2: 65.5,
    y2: 65.5,
    id: "Path",
    stroke: "#00A1DE",
    strokeWidth: 2,
    transform: "translate(6, 65.5) rotate(90) translate(-6, -65.5)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -53,
    y1: 257,
    x2: 65,
    y2: 257,
    id: "Path-Copy-2",
    stroke: "#00A1DE",
    strokeWidth: 2,
    transform: "translate(6, 257) rotate(90) translate(-6, -257)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    fill: "#00A1DE",
    cx: 6,
    cy: 125,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-3",
    fill: "#00A1DE",
    cx: 6,
    cy: 197,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#00A1DE",
    fill: "#FFFFFF",
    transform: "translate(6, 6) rotate(90) translate(-6, -6)",
    cx: 6,
    cy: 6,
    r: 5.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    stroke: "#00A1DE",
    fill: "#FFFFFF",
    transform: "translate(6, 316) rotate(90) translate(-6, -316)",
    cx: 6,
    cy: 316,
    r: 5.5
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectorFlightStop);
export default __webpack_public_path__ + "static/media/connector-flight-stop.78e2e2c09c598bf40fa5855a52499480.svg";
export { ForwardRef as ReactComponent };